@if (isVersionOutOfDate()) {
  <div class="version-sync-banner">
    <svg
      class="version-sync-banner__icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path
        d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"
      />
      <path d="M12 9v4" />
      <path d="M12 17h.01" />
    </svg>
    <p>
      {{ "shared.version_sync_banner.outdated_version_warning" | translate }}
    </p>
  </div>
}
